import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MonitorIcon } from 'lucide-react';
interface ToastProps {
  show: boolean;
  onClose: () => void;
}
export const Toast: React.FC<ToastProps> = ({
  show,
  onClose
}) => {
  useEffect(() => {
    if (show) {
      const timer = setTimeout(() => {
        onClose();
      }, 6000);
      return () => clearTimeout(timer);
    }
  }, [show, onClose]);
  return <AnimatePresence data-id="element-456" data-mp="12x13ygse5b78">
      {show && <div className="fixed inset-x-0 top-16 z-50 px-4 flex items-center justify-center pointer-events-none" data-id="element-457" data-mp="17vknybnfccwy">
          <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -20
      }} transition={{
        type: 'spring',
        damping: 25,
        stiffness: 350,
        duration: 0.3
      }} className="w-full max-w-md pointer-events-auto" role="alert" aria-live="polite" data-id="element-458" data-mp="syk56xn7nsam">
            <div className="bg-white border-l-4 border-[#D1005D] rounded-sm shadow-[0_4px_12px_rgba(0,0,0,0.1)]" data-id="element-459" data-mp="3il9gctuyp2h8">
              <div className="p-4 flex items-start space-x-3" data-id="element-460" data-mp="l8uw04i7gyex">
                <MonitorIcon className="h-5 w-5 text-[#D1005D] flex-shrink-0 mt-0.5" data-id="element-461" data-mp="lafozpovg9ao" />
                <p className="text-sm text-[#212326] font-medium leading-5" data-id="element-462" data-mp="z9xl6q4hyou2">
                  For the best data visualization experience, we recommend
                  viewing this report on a larger screen.
                </p>
              </div>
            </div>
          </motion.div>
        </div>}
    </AnimatePresence>;
};